module.exports = __webpack_public_path__ + "static/img/audio.73ca107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/audio.png
// module id = Lb5k
// module chunks = 136